import {useEffect, useState} from 'react';
import HRSidebar from '../../components/HR/HRSidebar';
import HRTopbar from '../../components/HR/HRTopbar';
import MetaData from '../../layouts/MetaData';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import PatientCoreFields, { patientCoreSchema, patientCoreInitial, diagnosisRuleError, toPatientPayload } from '../../components/PatientForm/PatientCoreFields';
import TextField from '../../components/Form/TextField';
import { PhoneField, SsnField, ZipField } from '../../components/Form/MaskedFields';
import StateSelectBox from '../../components/Form/StateSelectBox';
import PhoneTypeSelect from '../../components/Form/PhoneTypeSelect';
import GenderSelectbox from '../../components/Form/GenderSelectbox';
import { addPatient } from '../../actions/adminActions';
import {useDispatch, useSelector} from 'react-redux'
import { useAlert } from 'react-alert';
import ConsentRoleSelectBox from '../../components/Form/ConsentRoleSelectBox';
import OrganizationSelect from '../../components/Form/OrganizationSelect';
import { useHistory } from 'react-router-dom';
import { Alert } from 'react-bootstrap'; 
import {HIDE_ALERT_MESSAGE} from '../../constants/Common';


const HRAddPatient = (props) => {

    const dispatch = useDispatch();
    const alert = useAlert();
    const history = useHistory();
    
    const {message, error } = useSelector(state => state.common);

    useEffect(() => {
        if(error){
            alert.error(error);
            props?.history.push('/Nurse/Patients');

            dispatch({
                type: HIDE_ALERT_MESSAGE
            })

        }

        if(message) {
            alert.success(message);
            props?.history.push('/Nurse/Patients');  
            
            dispatch({
                type: HIDE_ALERT_MESSAGE
            })
        }

    }, [dispatch, alert, error, message]);


    const validate = Yup.object().shape({
        emrId: Yup.string().required("EHR-ID is required"),
		firstname: Yup.string()
        .required('First Name is required')
        .min(2, 'Should be atleast 2 characters')
        .max(20, 'Should be less than 20 characters'),
		lastname: Yup.string() 
		  .min(2, 'Should be atleast 2 characters')
		  .max(20, 'Should be less than 20 characters')
		  .required('Last Name is Required'),
        email: Yup.string().email('Enter a valid email address'),
		DOB:Yup.string().required('DOB is required'),
        phone1: Yup.string(),
        phoneType: Yup.string(),
        altPhone: Yup.string(),
        altPhoneType: Yup.string(),
        gender: Yup.string().required('Gender is required'),
        zipCode:Yup.string(),
        address:Yup.string(),
        city:Yup.string(),
        state:Yup.string(),
        line2: Yup.string(),
        ssn:Yup.string(),
        insurancecompany: Yup.string(),
	      ...patientCoreSchema,
    });

    const [orgId, setOrgId] = useState('');
    const [providerId, setProviderId] = useState('');
    const submitHandler = (values) => {
        if(!orgId){ alert.error('Organization is required'); return }
        values = {...values, organizationId: orgId, ...(providerId ? { assigned_doctor_id: providerId } : {})}
        const dxError = diagnosisRuleError(values);
        if (dxError) { alert.error(dxError); return }

        dispatch(addPatient(toPatientPayload(values)));
    }


  return <>
       <MetaData title="Add New Patient"/>
                <HRSidebar />    

                <section className="home-section">
                {/* TopBar */}
                <HRTopbar />

                <div className="shadow-lg p-3 mb-5 mr-4 ml-4 rounded" style={{backgroundColor: '#FAFAFA'}}>
                    <div className="home-content">
                    <div className="row-display">
                        <h5 style={{color: '#004aad'}}>
                            <strong>&nbsp;&nbsp;Add New Patient </strong>
                        </h5>

                        <div className="row-display"> 
                            <button className="btn btn-secondary btn-sm pt-2" onClick={() => history.goBack()}><i className='bx bx-arrow-back'>
                                </i>
                            </button> &nbsp;     
                        </div>
                    </div>
                    <hr />

                    <p style={{color: 'red', fontWeight: 'bold', marginTop: '8px'}}>*Required Field</p>
                

                        <Formik initialValues={{
                             ...patientCoreInitial,
                             emrId:'',
                             firstname: '',
                             lastname: '',
                             DOB: '',
                             gender: '',
                             diseases: ''
                         }}
                         validationSchema={validate}
                         onSubmit={values => {
                            submitHandler(values)
                        }}
                         >
                           <div>
                               <Form>
                               <div className="row">
                                    {/* EMR ID */}
                                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                        <TextField 
                                            label="EHR - ID" 
                                            name="emrId"  
                                            placeholder="EHR-ID"
                                            compulsory={true}
                                        />
                                    </div>

                                    {/* First Name */}
                                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                        <TextField 
                                            label="First Name" 
                                            name="firstname" 
                                            type="text" 
                                            placeholder="First Name"
                                            compulsory={true}
                                        />
                                    </div>

                                    {/* Last Name */}
                                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                        <TextField 
                                            label="Last Name" 
                                            name="lastname" 
                                            type="text" 
                                            placeholder="Last Name"
                                            compulsory={true}
                                        />
                                    </div>

                                    {/* Email */}
                                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                        <TextField 
                                            label="Email" 
                                            name="email" 
                                            type="email" 
                                            placeholder="Email"
                                        />
                                    </div>

                                    {/* DOB */}
                                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                    <TextField 
                                            label="DOB" 
                                            name="DOB" 
                                            type="date" 
                                            compulsory={true}
                                        />
                                    </div>

                                    {/* Gender */}
                                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                    <GenderSelectbox 
                                        label="Gender"
                                        name="gender"
                                        compulsory={true}
                                    />
                                    </div>

                                    {/* phone1 */}
                                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                        <PhoneField label="Patient Phone Number" name="phone1" placeholder="(XXX) XXX-XXXX" />
                                    </div>

                                     {/* Primary Phone Type */}
                                     <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                         <PhoneTypeSelect label="Phone Type" name="phoneType" />
                                     </div>

                                     {/* Alternative Phone */}
                                     <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                         <PhoneField label="Alternative Phone Number" name="altPhone" placeholder="(XXX) XXX-XXXX" />
                                     </div>

                                     {/* Alternative Phone Type */}
                                     <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                         <PhoneTypeSelect label="Alternative Phone Type" name="altPhoneType" />
                                     </div>


                                        <PatientCoreFields orgId={orgId} providerId={providerId} onProviderChange={setProviderId} showPhone={false} />
                                                                            {/* Organization (Session 3b) */}
                                        <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                            <OrganizationSelect value={orgId} onChange={setOrgId} practiceOnly />
                                        </div>

                                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                            <ConsentRoleSelectBox
                                                label="Consent Role"
                                                name="patientType"
                                            />
                                        </div>

                                     

                                </div>{/* row ends here */}

                                 {/* Buttons */}
                                 <br/>
                                 <div className="row mr-3" style={{ float: 'right'}}>
                                    <button className="btn btn-outline-danger btn-sm" type="reset">Reset</button> &nbsp;&nbsp;
                                    <button className="btn btn-outline-primary btn-sm" type="submit">Add Patient</button>
                                </div>

                                <br/><br/><br/>
                               </Form>
                           </div>
                        </Formik>   
                    </div>
                </div>

                </section>
  </>
};

export default HRAddPatient;
